import { bip } from "../../../../config/bip";

export const bipService = {
  getBip(variant = "desktop") {
    if (!bip.visible?.[variant]) {
      return null;
    }

    return bip;
  },
};